import { TOURNAMENT_ACTIONS } from "./constants";

const initialState = {
  tournament: {},
  isFetching: false,
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case TOURNAMENT_ACTIONS.update.request:
      return {
        ...state,
        isFetching: true,
      };
    case TOURNAMENT_ACTIONS.update.success:
      return {
        ...state,
        isFetching: false,
        tournament: action.payload,
      };
    case TOURNAMENT_ACTIONS.update.error:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducers;
